import { render, staticRenderFns } from "./CabinetAside.vue?vue&type=template&id=7d91aa70&scoped=true"
import script from "./CabinetAside.vue?vue&type=script&lang=js"
export * from "./CabinetAside.vue?vue&type=script&lang=js"
import style0 from "./CabinetAside.vue?vue&type=style&index=0&id=7d91aa70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d91aa70",
  null
  
)

export default component.exports